<div
  class="relative bg-gray-50 min-h-screen w-screen flex items-center justify-center"
>
  <div
    class="top-0 fixed z-20 transition-all duration-200 ease-in-out w-[calc(100vw-16rem)]"
  >
    <app-auth-top-bar class=""></app-auth-top-bar>
  </div>

  <div class="max-lg:hidden z-10 w-1/2 h-screen bg-gray-300">
    <app-custom-carousel></app-custom-carousel>
  </div>

  <!-- feedback form -->
 <div class="w-1/2 min-h-screen rounded-xl flex flex-col items-center justify-center mr-5 ml-5 ">
    <img src="assets/images/emblem.png" class="w-16 md:w-20" alt="" />
    <span class="text-black text-3xl font-bold mt-5 mb-2">
    Rate Your
    <span class="text-primary-600">Experience</span>
  </span>

  <div
      class="flex flex-col w-[50vw] mt-3 rounded-md border border-gray-300 bg-white p-4 px-4"
    >

      <h3 class="bg-primary-100 py-3 px-2 text-black">Submit Review</h3>
      <div class="flex gap-2">
    <ng-container *ngFor="let star of [0,1,2,3,4]; let i = index">
      <span
        class="text-4xl cursor-pointer transition-colors duration-150"
        [class.text-yellow-400]="i < (hoveredRating || selectedRating)"
        [class.text-gray-300]="i >= (hoveredRating || selectedRating)"
        (click)="setRating(i)"
        (mouseenter)="setHovered(i)"
        (mouseleave)="clearHover()"
      >★</span>
    </ng-container>
  </div>
      <main-dynamic-form
        [fields]="fields"
        [form]="form"
        [loading]="loading"
        [showRequiredTitle]="false"
        (submit)="handleFormSubmit($event)"
      ></main-dynamic-form>
    </div>
</div>
</div>


